import { captureException } from "../error";
import { NoomError } from "../error/NoomError";
import { sendBeacon } from "../fetch";
import { getRequestMetadata } from "../meristemContext";
import getStore from "../redux/store";
import { addMonitoringEventHandler } from "./bus";
import { mapEventName } from "./event-map";
import { maybeTrackExperimentStarted } from "./experiment-started";
import { generateMonitoringProps } from "./prop-registry";

addMonitoringEventHandler((event) => {
  if (event.type === "people_set") {
    pixelPeopleSet(event.properties);
  } else if (event.type === "track") {
    pixelTrackEvent(event.eventName, event.properties);
  }
});

/**
 * Set people properties using the growth pixel.
 */
function pixelPeopleSet(properties: JsonObject) {
  const people = JSON.stringify(properties);
  if (people === "{}") return;

  const { userData } = getStore().getState();
  sendPixelRequest("people_set", {
    mixpanel_distinct_id: userData.mixpanel_distinct_id,
    people,
  });
}

/**
 * Track events using the growth pixel.
 */
function pixelTrackEvent(name: string, properties: JsonObject) {
  let userData;

  // Avoid going boom if this is called before redux is init.
  try {
    ({ userData } = getStore().getState());
  } catch (e) {
    /* NOP */
  }

  const { meristemTrackingProperties, userState } = getRequestMetadata();

  const distinctId = userData?.mixpanel_distinct_id || userState.userId;
  if (!distinctId) {
    captureException(new NoomError("No distinct id found"));
    return;
  }

  const eventProperties = {
    ...meristemTrackingProperties,
    ...generateMonitoringProps(),
    ...properties,
  };

  maybeTrackExperimentStarted(name, eventProperties);

  sendPixelRequest(
    "track",
    {
      mixpanel_distinct_id: distinctId,
      currentUrl: document.URL,
      eventName: mapEventName(name),
      eventProperties,
    },
    "v3"
  );
}

function sendPixelRequest(
  requestType: string,
  requestBody: JsonObject,
  version = "v2"
) {
  if (typeof Cypress !== "undefined") {
    return;
  }
  // Remove Google Go's read aloud bot from traffic as this results in overcounting for traffic, without conversions.
  // Based on the evidence we could put together, this is run in conjunction with the actual browser, which itself
  // reports correctly.
  if (navigator.userAgent.includes("Google-Read-Aloud")) {
    return;
  }

  sendBeacon(`/pixel/${version}/i/${requestType}/`, requestBody);
}
